module.exports = __webpack_public_path__ + "img/financialResult_4.45a446a6.png";